import { Box, Grid } from '@mui/material';
import NavButton from './NavButton';
import PurchaseCosts from './PurchaseCosts';
import Incentives from './Incentives';

export default function CostsStep({
  myProject,
  incentives,
  onBack,
  onNext,
  onClickIncentivePrompt,
}) {
  return (
    <Box p={{ xs: 0, md: 4 }} width="100%">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={7}>
          <PurchaseCosts
            myProject={myProject}
            incentives={incentives}
            onClickIncentivePrompt={onClickIncentivePrompt}
          />
        </Grid>
        <Grid item xs={0} sm={5} display={{ xs: 'none', sm: 'block' }}>
          <Incentives
            myProject={myProject}
            incentives={incentives}
            onClickIncentivePrompt={onClickIncentivePrompt}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mt={2}>
        <Grid item xs={6}>
          <NavButton onClick={onBack} variant="secondary">
            Go Back
          </NavButton>
        </Grid>
        <Grid item xs={6}>
          <NavButton onClick={onNext} variant="primary">
            Continue
          </NavButton>
        </Grid>
      </Grid>
    </Box>
  );
}
